export default function errorPopup(state, action) {
	const newItem = {
		name: 'ErrorPopup',
		message: action.payload.message,
		id: (Math.random() * 1000000),
	};

	return {...state, popups: [...state.popups, newItem]};
}
